import { useTranslation } from 'react-i18next';
import { DeleteWorkScheduleSlotEventOccurence } from '@/components/modals/delete-work-schedule-slot-recurrence-modal/delete-work-schedule-slot-recurrence-modal.viewmodel';
import { Checkbox } from '@/components/ui/checkbox';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/form';
import { WorkScheduleSlotSequence } from '@/hooks/queries/use-get-office-work-schedules-slots';
import { useDeleteWorkScheduleSlotRecurrenceFormViewModel } from './delete-work-schedule-slot-recurrence-form.viewmodel';
import { deleteWorkScheduleSlotRecurrenceModes } from './schema';
import { DeleteWorkScheduleSlotRecurrenceUseForm } from './use-delete-work-schedule-slot-recurrence-form';

type Props = {
  form: DeleteWorkScheduleSlotRecurrenceUseForm;
  occurrence: DeleteWorkScheduleSlotEventOccurence;
  sequence: WorkScheduleSlotSequence;
};

const DeleteWorkScheduleSlotRecurrenceForm = ({
  form,
  sequence,
  occurrence,
}: Props) => {
  const { t } = useTranslation();

  const viewModel = useDeleteWorkScheduleSlotRecurrenceFormViewModel({
    sequence,
    occurrence,
  });
  const deleteModeOptions = deleteWorkScheduleSlotRecurrenceModes.map(
    (mode) => {
      let description: React.ReactNode;
      if (mode === 'stop-recurrence') {
        const exampleItems = viewModel.exampleItems;

        description = (
          <div className="text-muted-foreground text-sm">
            <ul className="list-inside list-disc">
              {exampleItems.map((item, index) => {
                return (
                  <li key={index}>
                    {t(item.day)} {item.date} - {t(item.periodOfTheDay)}
                  </li>
                );
              })}
              <li>...</li>
            </ul>
          </div>
        );
      } else {
        const exampleItems = [viewModel.exampleItems[0]!];

        description = (
          <div className="text-muted-foreground text-sm">
            <ul className="list-inside list-disc">
              {exampleItems.map((item, index) => {
                return (
                  <li key={index}>
                    {t(item.day)} {item.date} - {t(item.periodOfTheDay)}
                  </li>
                );
              })}
            </ul>
          </div>
        );
      }

      return {
        id: mode,
        value: mode,
        label: `delete-work-schedule-slot-recurrence-form.delete-option.${mode}`,
        description,
      };
    },
  );

  return (
    <Form {...form}>
      <form className="grid gap-4">
        <FormField
          control={form.control}
          name="mode"
          render={() => (
            <FormItem>
              {deleteModeOptions.map((mode) => (
                <FormField
                  key={mode.id}
                  name="mode"
                  render={({ field }) => {
                    return (
                      <FormItem
                        key={mode.id}
                        className="flex flex-col"
                      >
                        <div className="flex flex-row items-center space-x-3 space-y-0">
                          <FormControl>
                            <Checkbox
                              checked={field.value === mode.id}
                              onCheckedChange={(checked) => {
                                if (checked) {
                                  return field.onChange(mode.id);
                                }
                              }}
                            />
                          </FormControl>

                          <FormLabel className="cursor-pointer justify-center font-normal text-sm">
                            {t(mode.label)}
                          </FormLabel>
                        </div>

                        {mode.description && (
                          <div className="ml-8 text-muted-foreground text-sm">
                            {mode.description}
                          </div>
                        )}
                      </FormItem>
                    );
                  }}
                />
              ))}
            </FormItem>
          )}
        />
      </form>
    </Form>
  );
};

export default DeleteWorkScheduleSlotRecurrenceForm;
